

import React from "react";

const circleCheck = ({fill = "#C5C5C5"}) =>
<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16 8.5C16 12.9183 12.4183 16.5 8 16.5C3.58171 16.5 0 12.9183 0 8.5C0 4.08171 3.58171 0.5 8 0.5C12.4183 0.5 16 4.08171 16 8.5ZM7.07464 12.7359L13.0101 6.80045C13.2117 6.5989 13.2117 6.2721 13.0101 6.07055L12.2802 5.34064C12.0787 5.13906 11.7519 5.13906 11.5503 5.34064L6.70968 10.1812L4.44971 7.92126C4.24816 7.71971 3.92135 7.71971 3.71977 7.92126L2.98987 8.65116C2.78832 8.85271 2.78832 9.17952 2.98987 9.38106L6.34471 12.7359C6.54629 12.9375 6.87306 12.9375 7.07464 12.7359Z" fill={fill}/>
</svg>
export default circleCheck;
